<template>
	<div
		class="property-form"
		:class="{ 'shrink': !isVisible, 'bg-color-editing': isUserEditing !== user.id && isUserEditing }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<div class="property-title">
				{{ $t('Custom Command Properties') }} - {{ label ? label : 'Default Custom Command' }}
			</div>
		</div>
		<div class="property-content pr-2" :class="{'pointer-events-none': isLocked    ? isLocked.is_locked   : true}">
			<div class="form-group mb-5 pr-2px">
				<div class="select w-100 relative">
					<!-- select device -->
					<label class="text-primary">{{ $t('Active Device') }} </label>
					<custom-input
							class="mb-3"
							align="left"
							:label="$t('Label')"
							:required="isRequired"
							
							
							:max="40"
							:restrictChar="true"
							v-model="label"/>
					<div class="mb-2 mh-40px relative disabled">
						<div class="dot-green-connect" v-if="isConnect"></div>
						<div class="dot-red-connect" v-if="!isConnect"></div>
						<!-- v-model groupOption[0] is temporary -->
						<multiselect class="select-input select-input-atem-mini" v-model="groupOption[0]" deselect-label="" select-label="" track-by="key" label="label"
							placeholder="" :options="groupOption" :searchable="true" :allow-empty="true"  selectedLabel="" :show-labels="true">
							<span class="arrow-multiselect" slot="caret">
								<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
							</span>
							<template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
						</multiselect>
					</div>
					<div class="row pl-0 mr-0 ml-0 pr-0 mb-2">
						<div class="col-md mr-0 ml-0 pr-0 pl-0" >
						<!-- command list -->
							<div class="col-md mr-0 ml-0 pr-0 pl-0">
								<label class="text-primary">{{ $t('Command') }} </label>
							</div>
							<!-- <div class="mb-2 mh-40px">
								<multiselect class="select-input" v-model="command" deselect-label="" select-label="" track-by="key" label="label"
								placeholder="" :options="commandListOption" @input="onKeywordChange" :searchable="false" :allow-empty="true"  selectedLabel="" :show-labels="true">
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
								</multiselect>
							</div> -->
							<div class="col-md-12 mr-0 ml-0 pr-0 pl-0" :class="{'disabled': !isConnect}">
								<md-menu md-align-trigger md-direction="bottom-start" class="w-100">
									<div md-menu-trigger class="pl-0 ml-0 ">
										<custom-input
											class="w-100 pl-0 ml-0"
											v-if="command"
											type="selectSearch"
											:value="labelCommand"
											@remove="removeCommand()"
											:showClose="true"
											:disabled="!isConnect"
										/>
										<custom-input
											class="w-100 "
											v-click-outside="resetCommand"
											v-if="!command"
											type="selectSearchEmpty"
											v-model="searchCommand"
											:showClose="false"
											:disabled="!isConnect"
										/>
									</div>
									<md-menu-content id="scrolls-style" class="assets-item-wrapper-list ">
										<md-menu-item class="assets-item-wrapper-list item-property-rundown-customCommand" v-for="item in filteredCommand" @click="command = item"
											:key="item.key">{{item.label}}
										</md-menu-item>
										<md-menu-item v-if="filteredCommand.length <= 0" class="assets-item-wrapper-list item-property-rundown-customCommand">
											Not available
										</md-menu-item>
									</md-menu-content>
								</md-menu>
							</div>
						</div>
					</div>
				</div>

				<!-- custom parameter -->
				<div class="form-group">
					<div class="d-flex justify-content-between">
						<label class="text-primary">{{ $t('Parameter') }} </label>
						<label class="text-secondary text-small">{{ $t('Multiple parameters separated by comma') }} </label>
					</div>
					<input   name="parameter" class="form-control" v-model="customParameter" :disabled="!isConnect">
				</div>
				<div class="row ">
					<div class="col-md-6 mr-0 pr-2 ml-0">
						<custom-input
								type="duration-timer"
								align="left"
								:label="$t('Duration')"
								:disable="isPlayingLive"
								:required="isRequired"
								:maxTime="'86400'"
								:minTime="'0'"
								
								@keyenter="onInputEnter('duration', ...arguments)"
								v-model="duration"
							/>
					</div>
					<div class="col-md-6  pl-0">
						<div class="form-group ">
							<custom-input
								type="number"
								class="form-control "
								field="index"
								:label="$t('Layer')"
								:required="isRequired"
								:min="110"
								:max="150"
								:index-duplicated="isIndexDuplicated"
								
								@keyenter="onInputEnter('layer', ...arguments)"
								v-model="layerIndex"
							/>
						</div>
					</div>
				</div>
				<!-- on complete label -->
					<div class="mt-2">
							<div class="d-flex justify-content-between">
								<div>
									<label class="text-primary">{{ $t('On Complete') }}</label>
								</div>
							</div>
					</div>
					<!-- on complete controller -->
					<div class="">
						<md-menu
							:md-active.sync="isOnComplete"
							class="h-fc col-md-12 pr-0 pl-0"
							md-size="small"
							md-direction="top-start"
							md-align-trigger>
							<div v-if="selectedOnComplete"
								class="form-control cur-p relative mb-4"
								md-menu-trigger>
								<item-option
									:item="selectedOnComplete"
									v-if="selectedOnComplete"
								/>
								<div class="text-right">
									<div @click.stop="removeOnComplete" class="modal-close-assets absolute delete-complete-add">
										<i class="material-icons">cancel</i>
									</div>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control mb-4"
									:placeholder="$t('Stop (default)')"
									
									v-model="keywordSearchOnComplete"
									@click.stop="toggleOnComplete"
								/>
								<item-option
									:item="selectedOnComplete"
									v-if="selectedOnComplete"
								/>
							</div>
							<md-menu-content id="scrolls-style"
							:class="{'macro-content-wrapper-list': filteredParent.length > 6, 'assets-wrapper-list-empty': filteredParent.length === 0,
								'assets-wrapper-list-1': filteredParent.length === 1, 'assets-wrapper-list-2': filteredParent.length === 2,
								'assets-wrapper-list-3': filteredParent.length === 3, 'assets-wrapper-list-4': filteredParent.length === 4,
								'assets-wrapper-list-5': filteredParent.length === 5, 'assets-wrapper-list-6': filteredParent.length === 6,
								}"
								>
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in filteredParent"
									:key="rundownItem.id"
									@click="selectOnComplete(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
				<!-- parrent controller -->
				<div class="mt-2">
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Parent Controller') }}</label>
						</div>
						<div class="ml-0 pl-0">
							<md-switch
								:class="{'disabled': !isConnect}"
								class="md-primary mt-0 mb-2 mr-0"
								
								v-model="isParent">
							</md-switch>
						</div>
					</div>
				</div>
				<div class="d-flex select">
					<!-- new dropdown select assets -->
					<md-menu
						:md-active.sync="isToggleParent"
						class="h-fc mr-2 w-100"
						md-size="small"
						md-direction="bottom-start"
						md-align-trigger>
						<div v-if="selectedParent" :class="{'disabled-w-bg': !isConnect}"
							class="form-control cur-p relative w-100"
							md-menu-trigger>
							<item-option
								:item="selectedParent"
								v-if="selectedParent"
							/>
							<div @click.stop="selectedParent = null" class="modal-close-assets absolute delete-assets-add">
								<i class="material-icons">cancel</i>
							</div>
						</div>
						<div v-else md-menu-trigger :class="{'disabled-w-bg': !isConnect}">
							<input
								type="text"
								class="form-control w-100"
								:placeholder="$t('Search or Select Parent Item')"
								v-model="keywordSearchParent"
								@click.stop="toggleParent"
							/>
							<item-option
								:item="selectedParent"
								v-if="selectedParent"
							/>
						</div>
						<md-menu-content id="scrolls-style" class="macro-content-wrapper-list">
							<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
								v-for="rundownItem in filteredParent"
								:key="rundownItem.id"
								@click="selectParent(rundownItem)">
								<item-option :item="rundownItem" />
							</md-menu-item>
							<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
								Oops, there is no assets available
							</md-menu-item>
						</md-menu-content>
					</md-menu>
					<!-- delay -->
					<div class="select">
						<custom-input
							class="form-input mb-3"
							type="number"
							:label="$t('Delay')"
							:min="-15000"
							:max="15000"
							:step="100"
							:suffix="'ms'"
							v-model="childOrder"
							
							@keyenter="onInputEnter('delay', ...arguments)"
							:disabled="!isConnect"
							:allowNegative="true"
						/>
					</div>
				</div>
			</div>
			<div class="d-flex mt-4">
				<button @click="save()"
					:class="{ 'is-loading': isSaving }"
					class="btn btn-primary btn-sm mr-2">
					{{ $t('Save Changes') }}
				</button>
				<button @click="closeForm()"
					class="btn btn-secondary btn-sm">
					{{ $t('Cancel') }}
				</button>
			</div>
		</div>
		<!-- custom command -->
			<!-- <div class="d-flex justify-content-between ml-0 pl-0 mt-2">
				<label class="text-primary">{{ $t('Custom Command') }} </label>
			</div>
			<textarea  :class="{'textarea-custom-command-disabled': !isCustomCommand}" class="textarea-custom-command-idle" rows="8" v-model="customCommand" @input="onKeywordChange">
		</textarea> -->
		<!-- label -->
	</div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import Multiselect from 'vue-multiselect';
import ItemOption from '@/components/ItemOption.vue';
import { delay } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
// import fileApi from '@/api/file';
import CustomInput from '@/components/CustomInput.vue';
import {
	delayList,
} from '@/lib/statics';
import atemApi from '@/api/atem';

export default {
	name: 'CustomCommandProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		Multiselect,
		ItemOption,
		CustomInput,
	},
	data() {
		return {
			group: '',
			groupOption: [
				{ key: 'no_device', label: 'No Connected Device' },
				{ key: 'other_device', label: 'Other Device' },
				{ key: 'custom_command', label: 'Custom Command' },
			],
			command: '',
			commandListOption: [
				{ key: 'changeProgramInput', label: 'Set Input' },
				{ key: 'runMacro', label: 'Play Macros' },
				// { key: 'stop_macros', label: 'Stop Macros' },
				{ key: 'fadeToBlack', label: 'Fade to Black' },
				{ key: 'changeTransitionPosition', label: 'Set Transition' },
				{ key: 'changeTransitionType', label: 'Set Transition Type' },
				{ key: 'cutTransition', label: 'Cut Transition' },

				// { key: 'changeTransitionMix', label: 'Change Transition Mix' },
				{ key: 'changeUpstreamKeyState', label: 'Change Upstream Key' },
				{ key: 'changeUpstreamKeyNextBackground', label: 'Change UpstreamKey Next Background' },
				{ key: 'changeUpstreamKeyNextState', label: 'Change UpstreamKey Next State' },
				{ key: 'changeAuxInput', label: 'Change Aux Output' },
				{ key: 'changeDownstreamKeyOn', label: 'Change Downstream KeyOn' },
				{ key: 'changeDownstreamKeyTie', label: 'Change Downstream KeyTie' },
				{ key: 'autoDownstreamKey', label: 'Auto DownstreamKey' },
				{ key: 'changeAudioMasterGain', label: 'Change Audio Master Gain' },
				{ key: 'changeAudioChannelGain', label: 'Change Audio Channel Gain' },
				{ key: 'changeAudioChannelState', label: 'Change Audio Channel State' },
				// { key: 'sendAudioLevelNumber', label: 'Send Audio Level Number' },
				{ key: 'startRecordMacro', label: 'Start Record Macro' },
				{ key: 'stopRecordMacro', label: 'Stop Record Macro' },


			],
			// eslint-disable-next-line quotes
			customCommand: ``,
			customParameter: '',
			label: '',
			Type: 'custom_command',
			isSaving: false,
			isVisible: true,
			isLoading: false,
			isRequired: false,
			isActiveEdit: false,
			parentItem: null,
			isParent: false,
			delayList,
			childOrder: 0,
			isCustomCommand: false,
			isConnect: false,
			ipAddress: '',
			layerIndex: '',
			searchCommand: '',
			selectedParent: null,
			selectedOnComplete: null,
			keywordSearchParent: '',
			keywordSearchOnComplete: '',
			isToggleParent: false,
			isOnComplete: false,
			duration: '00:00:05',
		};
	},
	directives: {
		ClickOutside,
	},
	methods: {
		closeForm() {
			this.$emit('close');
		},
		toggleParent() {
			this.isToggleParent = true;
		},
		toggleOnComplete() {
			this.isOnComplete = true;
		},
		initData() {
			this.isVisible = true;
			this.reset();
			if (this.data) {
				let content = this.data.content;
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				} else {
					this.isActiveEdit = false;
				}
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				this.label = this.data.name;
				this.layerIndex = this.data.layer_index;
				if (content) {
					const indexGroup = this.groupOption.findIndex(({ key }) => key === content.group);
					this.group = this.groupOption[indexGroup];
					const indexCommand = this.commandListOption.findIndex(({ key }) => key === content.command);
					this.command = this.commandListOption[indexCommand];
					this.customParameter = content.customParameter;
					this.customCommand = content.customCommand;
					this.isParent = content.isParent || false;
					this.selectedParent = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.duration = content.duration || '00:00:00';
					this.childOrder = content.childOrder || 0;
				}
				if (this.group && this.group.key === 'custom_command') this.isCustomCommand = true;
				if (this.group && this.group.key !== 'custom_command') this.isCustomCommand = false;
			}
		},
		reset() {
			this.label = '';
		},
		save() {
			const parentItemId = this.selectedParent && this.selectedParent.id ? this.selectedParent.id : null;
			const onCompleteItemId = this.selectedOnComplete && this.selectedOnComplete.id ? this.selectedOnComplete.id : null;

			const content = {
				label: this.label,
				duration: this.duration,
				customParameter: this.customParameter,
				customCommand: this.customCommand,
				isParent: this.isParent,
				parentItem: parentItemId,
				onCompleteItem: onCompleteItemId,
				childOrder: this.childOrder,
			};
			if (this.command) content.command = this.command.key;
			// temporary
			if (this.groupOption[0]) content.group = this.groupOption[0].key;
			const contentString = JSON.stringify(content);
			const name = this.label ? this.label : 'Default Custom Command';
			const layer = this.layerIndex < 110 ? 110 : this.layerIndex;
			const params = {
				name,
				type: this.type,
				content: contentString,
				layer_index: layer,
				rundown_id: this.rundownId,
			};
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
				const content = JSON.parse(response.data.content);
				if (content && content.group === 'custom_command') this.isCustomCommand = true;
				if (content && content.group !== 'custom_command') this.isCustomCommand = false;
				this.closeForm();
			};
			const errorCallback = () => {
				this.isSaving = false;
				this.closeForm();
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			if (this.data) {
				rundownItemsApi.update(this.data.id, params, callback, errorCallback);
			} else {
				rundownItemsApi.create(params, callback, errorCallback);
			}
		},
		onKeywordChange() {
			delay(() => {
			}, 500);
		},
		selectParent(item) {
			this.selectedParent = item;
			this.keywordSearchParent = '';
		},
		removeParent() {
			this.selectedParent = null;
			this.keywordSearchParent = '';
		},
		selectOnComplete(item) {
			this.selectedOnComplete = item;
			this.keywordSearchOnComplete = '';
		},
		removeOnComplete() {
			this.selectedOnComplete = null;
			this.keywordSearchOnComplete = '';
		},
		checkConnection() {
			const callback = (response) => {
				const data = response.data;
				const model = data && data.model ? data.model : 'Atem';
				this.ipAddress = data.address;
				this.groupOption[0].label = `${model} (${this.ipAddress})`;
				this.isConnect = true;
			};
			const errorCallback = () => {
				this.ipAddress = '';
				this.isConnect = false;
			};
			atemApi.checkConnection(callback, errorCallback);
		},
		onInputEnter(props, value) {
			if (props === 'duration') this.duration = value;
			if (props === 'layer') this.layerIndex = value;
			if (props === 'delay') this.childOrder = value;
		},
		removeCommand() {
			this.command = '';
		},
		resetCommand() {
			this.searchCommand = '';
		},
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		isPlayingLive() {
			return this.data && !!this.data.is_play_live && this.data.is_play_live === 1;
		},
		filteredParent() {
			const filteredParent = this.items.filter(item => item.id !== this.data.id);
			let finalResult = filteredParent.filter(item => item.type !== 'separator');
			if (this.keywordSearchParent) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchParent.toUpperCase()));
				return finalResult;
			}
			if (this.keywordSearchOnComplete) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchOnComplete.toUpperCase()));
				return finalResult;
			}
			return finalResult;
		},
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.layerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		labelCommand() {
			let content = this.data.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			if (content && content.command) {
				const index = this.commandListOption.findIndex(({ key }) => key === content.command);
				if (index !== -1) return this.commandListOption[index].label;
			}
			return '';
		},
		filteredCommand() {
			if (this.searchCommand) {
				return this.commandListOption.filter(item => item.label.toLowerCase().includes(this.searchCommand));
			}
			return this.commandListOption;
		},
		isUserEditing() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index] ? this.items[index].active_edit : null;
		},
	},
	watch: {
		command() {
		},
		data() {
			if (this.data) {
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
					this.initData();
				} else {
					this.isActiveEdit = false;
				}
				if (this.data) {
					let content = this.data.content;
					if (typeof content === 'string') {
						content = JSON.parse(content);
					}
					this.label = this.data.name;
					if (content) {
						const indexGroup = this.groupOption.findIndex(({ key }) => key === content.group);
						this.group = this.groupOption[indexGroup];
						const indexCommand = this.commandListOption.findIndex(({ key }) => key === content.command);
						this.command = this.commandListOption[indexCommand];
						this.customParameter = content.customParameter;
						this.customCommand = content.customCommand;
						this.isParent = content.isParent;
						this.duration = content.duration;
						this.selectedParent = this.filteredItems.find(item => item.id === content.parentItem) || '';
						this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';

						this.childOrder = content.childOrder;
					}
				}
			}
		},
	},
	mounted() {
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		this.checkConnection();
		this.isRequired = false;
		this.$nextTick(() => {
			this.initData();
		});
		this.isLoading = true;
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 400);
	},

};
</script>
